import { useState } from "react";
import PRODUCTS from './products';

// ──────────────────────────────────────────────
// DATA  (피부 타입 5가지에만 집중)
// ──────────────────────────────────────────────
const QUESTIONS = [
  {
    tag: "세안 후",
    q: "세안 후 아무것도 바르지 않으면\n피부가 어떤가요?",
    icon: "💧",
    opts: [
      { t: "많이 당기고 불편해요", s: { dry: 3 } },
      { t: "약간 당기는 느낌이에요", s: { dry: 1, normal: 1 } },
      { t: "편안하고 촉촉해요", s: { normal: 2 } },
      { t: "금방 번들거리기 시작해요", s: { oily: 2 } },
    ],
  },
  {
    tag: "오후 피부",
    q: "낮이 되면 피부가\n어떻게 변하나요?",
    icon: "☀️",
    opts: [
      { t: "점점 건조해지고 각질이 생겨요", s: { dry: 2 } },
      { t: "T존만 약간 번들거려요", s: { combo: 3 } },
      { t: "얼굴 전체가 번들거려요", s: { oily: 3 } },
      { t: "별다른 변화가 없어요", s: { normal: 2 } },
    ],
  },
  {
    tag: "모공",
    q: "평소 나의 모공 상태는\n어떤가요?",
    icon: "🔍",
    opts: [
      { t: "모공이 거의 보이지 않아요", s: { dry: 1, normal: 1 } },
      { t: "T존 모공이 눈에 띄어요", s: { combo: 2 } },
      { t: "얼굴 전체 모공이 넓어요", s: { oily: 3 } },
      { t: "피부결이 고른 편이에요", s: { normal: 2 } },
    ],
  },
  {
    tag: "화장품 반응",
    q: "새로운 화장품을 사용하면\n어떤 반응이 나타나나요?",
    icon: "🌸",
    opts: [
      { t: "자주 트러블이나 발진이 생겨요", s: { sensitive: 3 } },
      { t: "가끔 트러블이 생기는 편이에요", s: { sensitive: 1 } },
      { t: "건조함이 심해지는 편이에요", s: { dry: 1, sensitive: 1 } },
      { t: "대부분 잘 맞는 편이에요", s: { normal: 1 } },
    ],
  },
  {
    tag: "피부 자극",
    q: "피부가 빨개지거나 가렵거나\n따가운 일이 자주 있나요?",
    icon: "🌡️",
    opts: [
      { t: "자주 그런 편이에요", s: { sensitive: 3 } },
      { t: "가끔 그런 편이에요", s: { sensitive: 1 } },
      { t: "계절 변화 때만 그래요", s: { dry: 1 } },
      { t: "거의 없어요", s: { normal: 1 } },
    ],
  },
];

const TYPES = {
  dry: {
    name: "건성 피부", emoji: "🌙",
    desc: "수분이 부족하여 피부가 자주 당기고 건조한 피부예요.\n충분한 보습과 수분 공급이 핵심 케어예요.",
    keywords: ["보습 집중", "각질 케어", "수분 장벽"],
    bg: "linear-gradient(160deg, #FDF0E4 0%, #F0D4B0 100%)",
    accent: "#B8733C",
    tip: "고보습 크림과 에센스를 레이어링해서 수분이 날아가지 않도록 막아주세요.",
  },
  oily: {
    name: "지성 피부", emoji: "✨",
    desc: "피지 분비가 활발하여 피부가 번들거리는 편이에요.\n피지 조절과 모공 관리에 집중한 케어가 필요해요.",
    keywords: ["피지 조절", "모공 관리", "가벼운 케어"],
    bg: "linear-gradient(160deg, #E4F0E8 0%, #B0D4BC 100%)",
    accent: "#2D7048",
    tip: "수분은 부족하지 않게, 유분은 잡아주는 밸런싱 제품을 선택하세요.",
  },
  combo: {
    name: "복합성 피부", emoji: "☯️",
    desc: "T존은 지성, U존은 건성인 복합적인 피부예요.\n부위별로 다른 케어를 해주는 것이 중요해요.",
    keywords: ["존별 케어", "유수분 밸런스", "맞춤 케어"],
    bg: "linear-gradient(160deg, #EDE4F0 0%, #CBB0D8 100%)",
    accent: "#6B3D80",
    tip: "T존에는 가벼운 젤 타입, 건조한 부위엔 크림 타입을 따로 사용해보세요.",
  },
  sensitive: {
    name: "민감성 피부", emoji: "🌸",
    desc: "외부 자극에 쉽게 반응하는 예민한 피부예요.\n저자극·순한 성분 위주의 케어가 가장 중요해요.",
    keywords: ["저자극 성분", "진정 케어", "장벽 강화"],
    bg: "linear-gradient(160deg, #F0E4E8 0%, #D8B0B8 100%)",
    accent: "#8B3A4A",
    tip: "향료·알코올이 없는 제품을 선택하고, 새 제품은 먼저 소량 테스트해보세요.",
  },
  normal: {
    name: "정상 피부", emoji: "🌟",
    desc: "유수분 밸런스가 잘 잡혀 있는 건강한 피부예요.\n현재 좋은 상태를 유지하는 케어를 해주세요.",
    keywords: ["밸런스 유지", "광채 관리", "예방 케어"],
    bg: "linear-gradient(160deg, #E4ECF0 0%, #B0C8D8 100%)",
    accent: "#1E5E80",
    tip: "자외선 차단만 꾸준히 해줘도 피부 상태를 오래 유지할 수 있어요.",
  },
};

// ──────────────────────────────────────────────
// LOGIC
// ──────────────────────────────────────────────
function calcResult(answers) {
  const sc = {};
  answers.forEach((a) =>
    Object.entries(a).forEach(([k, v]) => { sc[k] = (sc[k] || 0) + v; })
  );
  const { dry = 0, oily = 0, combo = 0, sensitive = 0, normal = 0 } = sc;
  if (sensitive >= 4) return "sensitive";
  const max = Math.max(dry, oily, combo, normal);
  if (dry === max && dry > 0) return "dry";
  if (oily === max && oily > 0) return "oily";
  if (combo === max && combo > 0) return "combo";
  return "normal";
}

// ──────────────────────────────────────────────
// RESULT VIEW
// ──────────────────────────────────────────────
function ResultView({ skinType, onRestart }) {
  const type = TYPES[skinType];
  const pool = PRODUCTS[skinType];

  // 풀에서 랜덤 3개 선택 (결과 볼 때마다 다르게)
  const prods = [...pool].sort(() => Math.random() - 0.5).slice(0, 3);

  return (
    <div className="result-page">
      <div className="result-hero" style={{ background: type.bg }}>
        <p className="label-xs">MY SKIN TYPE</p>
        <div className="hero-emoji">{type.emoji}</div>
        <h2 className="hero-name serif">{type.name}</h2>
        <p className="hero-desc">
          {type.desc.split("\n").map((l, i) => <span key={i}>{l}<br /></span>)}
        </p>
        <div className="kw-row">
          {type.keywords.map((k, i) => (
            <span key={i} className="kw-chip" style={{ color: type.accent, borderColor: type.accent }}>#{k}</span>
          ))}
        </div>
      </div>

      <div className="tip-card" style={{ borderColor: type.accent + "55" }}>
        <p className="tip-label" style={{ color: type.accent }}>💡 케어 팁</p>
        <p className="tip-text">{type.tip}</p>
      </div>

      <div className="prods-section">
        <h3 className="prods-title serif">맞춤 추천 제품</h3>
        <p className="prods-sub">올리브영에서 바로 구매할 수 있어요</p>
        <div className="prods-notice">
          ⚠️ 본 추천은 테스트 결과를 바탕으로 한 참고용 정보예요. 모든 피부는 개인마다 다르므로 실제 사용 전 성분과 본인 피부 상태를 반드시 확인해 주세요.
        </div>
        {prods.map((p, i) => (
          <a key={i} href={p.link} target="_blank" rel="noopener noreferrer" className="prod-card">
            <span className="prod-tag" style={{ color: type.accent, background: type.accent + "18" }}>{p.tag}</span>
            <p className="prod-name">{p.name}</p>
            <p className="prod-desc">{p.desc}</p>
            <div className="prod-reason" style={{ borderLeftColor: type.accent }}>
              <span className="prod-reason-label" style={{ color: type.accent }}>이 피부에 추천하는 이유</span>
              <p className="prod-reason-text">{p.reason}</p>
            </div>
            <div className="prod-footer">
              <span className="prod-cta" style={{ color: type.accent, background: type.accent + "18" }}>올리브영에서 보기 →</span>
            </div>
          </a>
        ))}
      </div>

      <button className="btn-outline" onClick={onRestart}>↩ 다시 테스트하기</button>

      <div className="disclosure">
        <p className="disclosure-icon">🛒</p>
        <p className="disclosure-text">
          본 페이지는 올리브영 쇼핑 큐레이터 활동의 일환으로 제작되었으며,
          링크를 통해 구매가 발생할 경우 일정액의 수수료를 제공받을 수 있습니다.
        </p>
      </div>
    </div>
  );
}

// ──────────────────────────────────────────────
// MAIN APP
// ──────────────────────────────────────────────
export default function App() {
  document.title = "나의 피부 타입 테스트";
  const [phase, setPhase] = useState("intro");
  const [qIdx, setQIdx] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [chosenIdx, setChosenIdx] = useState(null);
  const [result, setResult] = useState(null);
  const [visible, setVisible] = useState(true);

  const handleAnswer = (scores, optIdx) => {
    if (chosenIdx !== null) return;
    setChosenIdx(optIdx);
    const newAnswers = [...answers, scores];

    setTimeout(() => {
      if (qIdx < QUESTIONS.length - 1) {
        setVisible(false);
        setTimeout(() => {
          setChosenIdx(null);
          setAnswers(newAnswers);
          setQIdx((i) => i + 1);
          setVisible(true);
        }, 260);
      } else {
        setResult(calcResult(newAnswers));
        setPhase("result");
      }
    }, 400);
  };

  const restart = () => {
    setPhase("intro");
    setQIdx(0);
    setAnswers([]);
    setChosenIdx(null);
    setResult(null);
    setVisible(true);
  };

  const q = QUESTIONS[qIdx];

  return (
    <>
      <style>{CSS}</style>

      {/* ── INTRO ── */}
      {phase === "intro" && (
        <div className="page intro-page">
          <div className="deco c1" /><div className="deco c2" /><div className="deco c3" />
          <div className="intro-inner">
            <p className="label-xs" style={{ color: "#C4864A", letterSpacing: "4px" }}>SKIN ANALYSIS</p>
            <h1 className="intro-title serif">나의 피부 타입을<br />알아보세요</h1>
            <p className="intro-sub">5가지 질문으로 알아보는<br />맞춤 피부 타입 &amp; 화장품 추천</p>
            <div className="dot-row">
              {QUESTIONS.map((_, i) => (
                <span key={i} className="dot" style={{ animationDelay: `${i * 0.09}s` }} />
              ))}
            </div>
            <button className="btn-primary" onClick={() => setPhase("quiz")}>테스트 시작하기</button>
            <p className="hint">약 1분 소요 · 5문항</p>
          </div>
        </div>
      )}

      {/* ── QUIZ ── */}
      {phase === "quiz" && (
        <div className="page quiz-page">
          <div className="prog-rail">
            <div className="prog-fill" style={{ width: `${((qIdx + 1) / QUESTIONS.length) * 100}%` }} />
          </div>
          <div className="quiz-meta">
            <span className="q-tag">{q.tag}</span>
            <span className="q-count serif">{qIdx + 1} / {QUESTIONS.length}</span>
          </div>
          <div className={`quiz-body ${visible ? "vis" : "gone"}`}>
            <div className="q-icon">{q.icon}</div>
            <h2 className="q-text serif">
              {q.q.split("\n").map((l, i) => <span key={i}>{l}<br /></span>)}
            </h2>
            <div className="opts">
              {q.opts.map((opt, i) => (
                <button
                  key={i}
                  className={`opt-btn ${chosenIdx === i ? "chosen" : ""}`}
                  onClick={() => handleAnswer(opt.s, i)}
                  disabled={chosenIdx !== null}
                >
                  <span className="opt-letter">{String.fromCharCode(65 + i)}</span>
                  <span className="opt-text">{opt.t}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* ── RESULT ── */}
      {phase === "result" && result && (
        <ResultView skinType={result} onRestart={restart} />
      )}
    </>
  );
}

// ──────────────────────────────────────────────
// STYLES
// ──────────────────────────────────────────────
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400;600&family=Noto+Sans+KR:wght@300;400;500;700&display=swap');

*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
body { font-family: 'Noto Sans KR', sans-serif; background: #FAF8F4; color: #2C2420; min-height: 100vh; }
.serif { font-family: 'Cormorant Garamond', serif; }
.label-xs { font-family: 'Cormorant Garamond', serif; font-size: 11px; letter-spacing: 3px; margin-bottom: 18px; display: block; }

.page { min-height: 100vh; max-width: 640px; margin: 0 auto; display: flex; flex-direction: column; position: relative; }

/* INTRO */
.intro-page { align-items: center; justify-content: center; text-align: center; overflow: hidden; }
.intro-inner { position: relative; z-index: 2; padding: 40px 32px; width: 100%; }
.deco { position: absolute; border-radius: 50%; pointer-events: none; }
.c1 { width: 340px; height: 340px; top: -110px; right: -90px; background: radial-gradient(circle, rgba(232,196,152,0.22) 0%, transparent 70%); }
.c2 { width: 240px; height: 240px; bottom: 60px; left: -80px; background: radial-gradient(circle, rgba(210,190,180,0.18) 0%, transparent 70%); }
.c3 { width: 180px; height: 180px; top: 42%; left: 62%; background: radial-gradient(circle, rgba(228,160,160,0.15) 0%, transparent 70%); }

.intro-title { font-size: 52px; font-weight: 600; line-height: 1.2; color: #2C2420; margin-bottom: 16px; }
.intro-sub { font-size: 16px; font-weight: 300; color: #8A7A70; line-height: 2; margin-bottom: 36px; }

.dot-row { display: flex; gap: 7px; justify-content: center; margin-bottom: 44px; }
.dot { width: 7px; height: 7px; border-radius: 50%; background: #C4864A; opacity: 0; animation: popIn 0.35s ease forwards; }
@keyframes popIn { from { opacity: 0; transform: scale(0.4); } to { opacity: 1; transform: scale(1); } }

.btn-primary { display: block; width: 100%; max-width: 260px; margin: 0 auto 14px; padding: 17px 28px; background: #2C2420; color: #FAF8F4; border: none; border-radius: 50px; font-family: 'Noto Sans KR', sans-serif; font-size: 15px; font-weight: 500; cursor: pointer; letter-spacing: 0.3px; transition: background 0.22s, transform 0.22s, box-shadow 0.22s; }
.btn-primary:hover { background: #C4864A; transform: translateY(-3px); box-shadow: 0 12px 28px rgba(196,134,74,0.3); }
.hint { font-size: 12px; color: #B0A090; font-weight: 300; }

/* QUIZ */
.quiz-page { background: #FAF8F4; }
.prog-rail { width: 100%; height: 3px; background: #EDE7E0; flex-shrink: 0; }
.prog-fill { height: 100%; background: linear-gradient(90deg, #C4864A, #E8B09A); transition: width 0.45s ease; }
.quiz-meta { display: flex; justify-content: space-between; align-items: center; padding: 20px 24px 0; flex-shrink: 0; }
.q-tag { background: #F5EDE4; color: #C4864A; padding: 5px 14px; border-radius: 20px; font-size: 11px; font-weight: 500; letter-spacing: 0.3px; }
.q-count { font-size: 16px; color: #B0A090; font-weight: 300; }

.quiz-body { flex: 1; padding: 28px 24px 44px; transition: opacity 0.26s ease, transform 0.26s ease; }
.quiz-body.vis  { opacity: 1; transform: translateX(0); }
.quiz-body.gone { opacity: 0; transform: translateX(-16px); }

.q-icon { font-size: 46px; line-height: 1; margin-bottom: 18px; }
.q-text { font-size: 34px; font-weight: 600; line-height: 1.36; color: #2C2420; margin-bottom: 36px; }

.opts { display: flex; flex-direction: column; gap: 12px; }
.opt-btn { display: flex; align-items: center; gap: 14px; padding: 17px 20px; border: 1.5px solid #EDE7E0; border-radius: 18px; background: #FFFFFF; cursor: pointer; text-align: left; font-family: 'Noto Sans KR', sans-serif; transition: border-color 0.18s, background 0.18s, transform 0.18s; }
.opt-btn:hover:not(:disabled) { border-color: #C4864A; background: #FEF9F4; transform: translateX(5px); }
.opt-btn.chosen { border-color: #C4864A; background: #FDF0E4; transform: translateX(5px); }
.opt-btn:disabled { cursor: default; }

.opt-letter { width: 30px; height: 30px; border-radius: 50%; background: #F5EDE4; color: #C4864A; font-size: 12px; font-weight: 700; display: flex; align-items: center; justify-content: center; flex-shrink: 0; transition: background 0.18s, color 0.18s; }
.opt-btn.chosen .opt-letter { background: #C4864A; color: #fff; }
.opt-text { font-size: 15px; color: #3A3028; font-weight: 400; line-height: 1.5; }

/* RESULT */
.result-page { max-width: 640px; margin: 0 auto; min-height: 100vh; background: #FAF8F4; display: flex; flex-direction: column; }
.result-hero { padding: 88px 40px 52px; text-align: center; }
.hero-emoji { font-size: 80px; line-height: 1; margin-bottom: 20px; }
.hero-name { font-size: 44px; font-weight: 600; color: #2C2420; margin-bottom: 16px; }
.hero-desc { font-size: 16px; line-height: 1.9; color: #5A4A40; font-weight: 300; max-width: 420px; margin: 0 auto 22px; }
.kw-row { display: flex; gap: 8px; justify-content: center; flex-wrap: wrap; }
.kw-chip { font-size: 12px; padding: 5px 13px; border: 1px solid; border-radius: 20px; font-weight: 500; }

.tip-card { margin: 32px 32px 20px; padding: 20px 24px; background: #fff; border: 1.5px solid; border-radius: 18px; }
.tip-label { font-size: 13px; font-weight: 700; margin-bottom: 7px; letter-spacing: 0.2px; }
.tip-text { font-size: 14px; color: #5A4A40; line-height: 1.75; font-weight: 300; }

.prods-section { padding: 20px 32px 24px; }
.prods-title { font-size: 30px; font-weight: 600; color: #2C2420; margin-bottom: 4px; }
.prods-sub { font-size: 14px; color: #A09080; font-weight: 300; margin-bottom: 12px; }
.prods-notice { font-size: 12px; color: #A09080; line-height: 1.8; font-weight: 300; background: #F5F3EF; border-radius: 12px; padding: 12px 14px; margin-bottom: 20px; }

.prod-card { display: block; background: #fff; border: 1px solid #EDE7E0; border-radius: 20px; padding: 20px; margin-bottom: 14px; text-decoration: none; transition: transform 0.18s, box-shadow 0.18s; }
.prod-card:hover { transform: translateY(-3px); box-shadow: 0 10px 28px rgba(44,36,32,0.08); }
.prod-tag { display: inline-block; font-size: 11px; padding: 4px 11px; border-radius: 20px; font-weight: 500; margin-bottom: 10px; }
.prod-name { font-size: 16px; font-weight: 700; color: #2C2420; margin-bottom: 7px; line-height: 1.5; }
.prod-desc { font-size: 14px; color: #7A6A60; margin-bottom: 14px; line-height: 1.6; font-weight: 300; }
.prod-reason { border-left: 3px solid; padding: 10px 14px; background: #FAFAF8; border-radius: 0 10px 10px 0; margin-bottom: 16px; }
.prod-reason-label { display: block; font-size: 10px; font-weight: 700; letter-spacing: 0.4px; margin-bottom: 5px; text-transform: uppercase; }
.prod-reason-text { font-size: 12.5px; color: #5A4A40; line-height: 1.75; font-weight: 300; }
.prod-footer { display: flex; justify-content: space-between; align-items: center; }
.prod-price { font-size: 14px; font-weight: 700; color: #2C2420; }
.prod-cta { font-size: 12px; font-weight: 500; padding: 7px 14px; border-radius: 20px; }

.btn-outline { width: calc(100% - 64px); margin: 8px 32px 52px; padding: 17px; background: transparent; border: 1.5px solid #2C2420; border-radius: 50px; color: #2C2420; font-family: 'Noto Sans KR', sans-serif; font-size: 14px; font-weight: 500; cursor: pointer; transition: background 0.2s, color 0.2s; }
.btn-outline:hover { background: #2C2420; color: #FAF8F4; }

.disclosure { margin: -36px 32px 40px; padding: 16px 18px; background: #F5F3EF; border-radius: 14px; text-align: center; }
.disclosure-icon { font-size: 16px; margin-bottom: 7px; }
.disclosure-text { font-size: 11px; color: #A09080; line-height: 1.8; font-weight: 300; }
`;
